


































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Shared types
import { PriceType, ServiceProduct } from '@coldtec/cos-types';

// Store types
import { ProductType, ToolProduct } from '@/store/store.types';

/**
 *  Component to render a product in the overview,
 *  including his name, price and possibly count.
 */
@Component
export default class OverviewProduct extends Vue {

    @Prop({ type: Object, required: true })
    private toolProduct!: ToolProduct;

    /**
     *  Holding the (translated) frequency of the price.
     */
    private frequency: string | null = null;

    /**
     *  Holding the translations of every price type / frequency.
     */
    private priceTypes: { [type: string]: string } = {
        [PriceType.Monthly]: 'per maand',
        [PriceType.Yearly]: 'per jaar',
    }

    /**
     *
     *  Used to get the count of how many times this product is added.
     *
     *  (i) Only applicable to additional products
     *
     */
    private get count(): number | null {

        return this.toolProduct.amount > 1
            ? this.toolProduct.amount
            : null;

    }

    /**
     *  Check if a price frequency should be rendered.
     */
    private created(): void {

        if (this.toolProduct.type === ProductType.Additional) {

            return;

        }

        const productData = this.toolProduct.data as ServiceProduct;

        if (!productData.type || productData.type === PriceType.OneTime) {

            return;

        }

        this.frequency = this.priceTypes[productData.type];

    }

}
